export default __webpack_public_path__ + "static/media/keymanagement.d7b5d921.svg";